import { css, cx } from "styled-system/css";
import type { HTMLAttributes, ReactNode } from "react";

const base = css({
  display: "inline-flex",
  alignItems: "center",
  px: "2",
  py: "0.5",
  rounded: "md",
  fontSize: "xs",
  fontWeight: "medium",
});

const tones = {
  neutral: css({ bg: "bg.muted", color: "fg.muted" }),
  success: css({ bg: "green.100", color: "green.800", _dark: { bg: "green.900", color: "green.100" } }),
  warning: css({ bg: "yellow.100", color: "yellow.900", _dark: { bg: "yellow.900", color: "yellow.100" } }),
  danger: css({ bg: "red.100", color: "red.800", _dark: { bg: "red.900", color: "red.100" } }),
};

export type BadgeTone = keyof typeof tones;

export function Badge({
  tone = "neutral",
  className,
  children,
}: HTMLAttributes<HTMLSpanElement> & { tone?: BadgeTone; children: ReactNode }) {
  return (
    <span className={cx(base, tones[tone], className)}>
      {children}
    </span>
  );
}
